import { render } from "./PatientShowOffcanvas.vue?vue&type=template&id=38bcdb77&scoped=true"
import script from "./PatientShowOffcanvas.vue?vue&type=script&lang=js"
export * from "./PatientShowOffcanvas.vue?vue&type=script&lang=js"

import "./PatientShowOffcanvas.vue?vue&type=style&index=0&id=38bcdb77&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bcdb77"]])

export default __exports__